// @ts-nocheck
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap-v5";
import Select from 'react-select';
import { ToastContainer } from 'react-toastify';
import DailySalesReport from '../components/DailySalesReport';
import EmployeeWiseSalesReport from '../components/EmployeeWiseSalesReport';
import GetPagePermission from "../components/GetPagePermission";
import { useLocation } from "react-router-dom";

export default function MisReports() {

    const hasDailySalesReportPermission = GetPagePermission("/daily-sales-report");
    const hasEmployeeWiseSalesReportPermission = GetPagePermission("/employee-wise-sales-report");

    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [currentReport, setCurrentReport] = useState({ label: 'Select a Report', value: '' });
    const [availableReports, setAvailableReports] = useState([{ label: 'Select a Report', value: '' }]);

    useEffect(() => {
        const updatedReports = [{ label: 'Select a Report', value: '' }];

        if (hasDailySalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Daily Sales Report', value: 'dailySalesReport' });
        }

        if (hasEmployeeWiseSalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Employee Wise Sales Report', value: 'employeeWiseSalesReport' });
        }

        updatedReports.sort((a, b) => a.label.localeCompare(b.label));
        setAvailableReports(updatedReports);
        // eslint-disable-next-line
    }, [hasDailySalesReportPermission, hasEmployeeWiseSalesReportPermission]);

    useEffect(() => {
        if (query.get('type') === 'dailySalesReport') {
            setCurrentReport({ label: 'Sales >> Daily Sales Report', value: 'dailySalesReport' });
        }

        if (query.get('type') === 'employeeWiseSalesReport') {
            setCurrentReport({ label: 'Sales >> Employee Wise Sales Report', value: 'employeeWiseSalesReport' });
        }
        // eslint-disable-next-line
    }, [query.get('type')]);

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className="card-title">
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            MIS Report Viewer
                        </span>
                    </div>
                </div>
                <div className='card-body pt-0'>
                    <Row>
                        <Col xs={8} md={10} lg={10}>
                            <Select
                                className="form-select-sm"
                                value={currentReport}
                                onChange={(e: any) => setCurrentReport(e)}
                                options={availableReports}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Col>
                        <Col xs={4} md={2} lg={2} className={"form-control-sm ps-0"}>
                            <button type="button" className="btn btn-primary btn-sm w-100 h-100">Generate</button>
                        </Col>
                    </Row>
                    <div className="mt-5">
                        {currentReport.value === 'dailySalesReport' && hasDailySalesReportPermission && <DailySalesReport />}
                        {currentReport.value === 'employeeWiseSalesReport' && hasEmployeeWiseSalesReportPermission && <EmployeeWiseSalesReport />}
                        <ToastContainer />
                    </div>
                </div>
            </div>
        </>
    );
}
